// Returns true for clicks on chip-remove or fullscreen-trigger controls
// so the wrapper click handler can keep their native behaviour intact.
export const shouldSkipMultiSelectWrapperClick = (
  target: EventTarget | null,
  chipRemoveSelector: string,
  fullscreenTriggerSelector: string
): boolean => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  // Keep native behavior on chip remove and fullscreen trigger controls.
  return Boolean(
    target.closest(chipRemoveSelector) ||
      target.closest(fullscreenTriggerSelector)
  );
};
